import { Component, OnInit, TemplateRef } from '@angular/core';
import { CartService } from '../../services/cart.service';
import { environment } from 'src/environments/environment';
import { ProductService } from 'src/app/product/services/product.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AlertService } from 'src/app/core/services/alert.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { Router, NavigationEnd } from '@angular/router';
import { SharedConsts } from 'src/app/shared/constants';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { Subscription } from 'rxjs';
import { CartModuleConsts } from '../../contants';

@Component({
    selector: 'my-cart',
    templateUrl: './my-cart.component.html',
    styleUrls: ['./my-cart.component.scss', '../../cart.component.scss'],
    standalone: false
})
export class MyCartComponent implements OnInit {
  removeItemsCount = 0;
  loading1 = false;
  componentLoaded = false;
  recommendedProducts: any;
  nextPage1 = 1;
  salesRepDetail: any;
  productList1 = []
  totalProductPages1 = 1;
  totalProductCount1 = 0;
  noRecord1 = true;
  page_size = environment.cart_page_size
  imagePath = environment.s3_path + '/' + environment.product_image_folder + '/'
  profileImagePath = environment.s3_path + '/' + environment.profileFolder
  loading2 = false;
  nextPage2 = 1;
  productList2 = []
  totalProductPages2 = 1;
  totalProductCount2 = 0;
  noRecord2 = true;
  allProductCounts: any;
  getCartItemsApiSubscribe:any;
  recommendationListSubscription$!:Subscription;
  hasAlreadyGetItemsCall = false;
  removeProduct = {};
  selectedRecommendation=''
  removeType = '';
  global_data:any ={};
  bsModalRef: BsModalRef;
  removeHeading = '';
  previousUrl: string;
  currentUrl: string;
  checkIfAllDataLoaded:boolean=false;
  is_retailer:any=false;
  constructor(private cartService: CartService, private productService: ProductService,
    private statePersist: StatePersistService,
    private modalService: BsModalService, private alertService: AlertService,
    private googleAnalyticsService: GoogleAnalyticsService,
    public loaderService: LoaderService,
    private router: Router) { 
      this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {  
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        this.statePersist.setLocalStorage('previous_url',  this.previousUrl)
      }
    });
    }

  ngOnInit(): void {
    var currentuser = this.statePersist.getLocalStorage('currentUser')
    var selectedretailer = this.statePersist.getLocalStorage('selectedRetailer') || ''
    if ((currentuser.is_telesales_user || currentuser.is_sales_rep || currentuser.is_head_office_user) && selectedretailer !== ''){
      this.is_retailer = false
    }
    else{
      this.is_retailer = true
    }
    this.statePersist.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersist.getLocalStorage('global_data')
    })

    this.loaderService.watchLoader().subscribe(message => {
        this.checkIfAllDataLoaded = !message;
    })
    this.statePersist.removeLocalStorage('back-to-product-listing')
    this.statePersist.removeLocalStorage('scrollElementId')
    this.allProductCounts = {};
    this.salesRepDetail = {};
    this.getCartItems();

    this.recommendedProductsList();
        
  }

  recommendedProductsList(){
    this.recommendationListSubscription$ = this.cartService.getRecommendedItems().subscribe({
      next:(response:any)=>{
        if(response.response){
          this.noRecord2 = true;
          const dataobj = response.response.recommendations
          this.recommendedProducts = [...dataobj];
          if (this.recommendedProducts.length >0){
            this.noRecord2 = false;
          }
          }
          this.loading2 = false;
          
        }}
    )
      }

  ngAfterViewInit() {
    this.getCartItemsApiSubscribe = this.statePersist.watchMyCartDetail().subscribe(message => {
    
      if (!this.hasAlreadyGetItemsCall)
      { 
      
        this.nextPage1 = 1;
        this.productList1 = []
        this.totalProductPages1 = 1;
        this.totalProductCount1 = 0;
        this.statePersist.emitmobileListCountDetails('mobile count change')
        this.getCartItems();
      }
      
    })

}

ngOnDestroy(){
  if (this.getCartItemsApiSubscribe){
    this.getCartItemsApiSubscribe.unsubscribe()

  }
}

  getCartItems() {
    this.hasAlreadyGetItemsCall = true
    this.cartService.getCartItems({"page_size": this.page_size,'page':this.nextPage1})
    .subscribe(
      data => {
        if (data.response) {
          if (data.status == 2212){
            this.alertService.error(data.response)
          }
          const product_list = data.response.items;
          this.totalProductCount1 = data.response.product_count 
          this.totalProductPages1 = data.response.total_pages;
          
          if (this.totalProductPages1 < this.nextPage1 + 1) {
            this.nextPage1 = null;
          }
          else {
            this.nextPage1 += 1;
          }
          if (data.response.total_product_count === 0) {
            this.noRecord1 = true;
            this.productList1 = [];
            this.nextPage1 = 1;
            this.totalProductCount1 = 0;
            this.totalProductPages1 = 1
          }
          else {
            this.noRecord1 = false;

          }
          for (let i = 0; i < product_list.length; i++) {
            this.productList1.push(product_list[i]);
          }
          if (data.response.out_of_stock_remove == 1){
            this.statePersist.emitmobileListCountDetails('mobile count change')
          }
        }
        this.loading1 = false;
        this.componentLoaded = true;
        this.hasAlreadyGetItemsCall = false;
      }
    );
  }

  onScrollDown1() {

    if ((this.nextPage1 != 1 && this.nextPage1 !== null) && !this.loading1) {
      this.loading1 = true;
      this.getCartItems()
    }

  }

  toInteger(value) {
    return parseInt(value)
  }

  getSalesRepCartItems(msg) {
    if (msg.includes('norefresh')){
      this.noRecord2 = true;
      this.productList2 = [];
      this.nextPage2 = 1;
      this.totalProductCount2 = 0;
      this.totalProductPages2 = 1
    }
    else{
      this.cartService.getSalesRepCartItems({"page_size": this.page_size,'page':this.nextPage2})
      .subscribe(
        data => {
          if (data.response) {
            
            const product_list = data.response.items;
            this.salesRepDetail = data.response.sales_rep;
            this.totalProductCount2 = data.response.product_count
            this.totalProductPages2 = data.response.total_pages;
            if (this.totalProductPages2 < this.nextPage2 + 1) {
              this.nextPage2 = null;
            }
            else {
              this.nextPage2 += 1;
            }
            if (data.response.total_product_count === 0) {
              this.noRecord2 = true;
              this.productList2 = [];
              this.nextPage2 = 1;
              this.totalProductCount2 = 0;
              this.totalProductPages2 = 1
            }
            else {
              this.noRecord2 = false;
  
            }
            for (let i = 0; i < product_list.length; i++) {
              this.productList2.push(product_list[i]);
            }
            if (data.response.out_of_stock_remove == 1){
              this.statePersist.emitmobileListCountDetails('mobile count change')
            }
          }
          this.loading2 = false;
        }
      );
    }
   
  }

  onScrollDown2() {
    if ((this.nextPage2 != 1 && this.nextPage2 !== null) && !this.loading2) {
      this.loading2 = true;
      this.getSalesRepCartItems('')
    }

  }

  qytUpdate(product, qyt, type, template: any, recommend_id) {
    if (qyt == 0){
      qyt = 1
      this.removeType = type
      if (type == 'list1'){
        for (let i = 0; i < this.productList1.length; i++) {
          if (this.productList1[i]['product_id'] == product.product_id) {
            this.productList1[i]['item_qty'] = '0'
          }
        }
      }
      else{
        for (let i = 0; i < this.recommendedProducts.length; i++) {
          if (this.recommendedProducts[i].recommend_id == recommend_id){
            
            for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
              if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
                this.recommendedProducts[i].products[j]['item_qty'] = '0'
              }
            }
          }}
      }
      
      this.removeonSpinnerPopup(template, product, type, recommend_id)
    }
    else{
      this.statePersist.amendQtyGoogleanalyticsEvent()
      this.productService.qytUpdate({ 'item_id': parseInt(product.item_id), 'qty': qyt, 'collect_totals':true})
      .subscribe(
        data => {
          if (data.response) {
            
            if (type == 'list1'){
              if (data.status == 1169) {
                this.productList1 = this.productList1.filter(item => item.item_id !== product.item_id);
              }
              else if(data.status == 2212){
                
                for (let i = 0; i < this.productList1.length; i++) {
                  var qty = this.productList1[i]['item_qty'];
                  if (this.productList1[i]['product_id'] == product.product_id) {
                    this.productList1[i]['item_qty'] = qty;
                  }
                }
                this.alertService.error(data.response)
              }
              else if(data.status == 1180){
                
                for (let i = 0; i < this.productList1.length; i++) {
                  var qty = this.productList1[i]['item_qty'];
                  if (this.productList1[i]['product_id'] == product.product_id) {
                    this.productList1[i]['item_qty'] = qty;
                  }
                }
                localStorage.setItem('closeStorInfoMessage', data.response.msg)
                document.getElementById("openclosedStoreInfo").click();
                const currentUrl = this.router.url;
                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                  this.router.navigate([currentUrl]);
                });
              }
              else if (data.status == 1163) {
                this.productList1 = this.productList1.filter(item => item.item_id !== product.item_id);
                this.statePersist.emitoutOfStockData('out of stock update')
              }
              else if (data.status == 2211){
                this.alertService.error(data.response)
                this.productList1 = [];
                this.nextPage1 = 1;
                this.totalProductCount1 = 0;
                this.totalProductPages1 = 1
                this.noRecord1 = true;
                this.getCartItems()
                this.statePersist.emitOrderDetailData('updae order Deatil')
              }
              else {
                for (let i = 0; i < this.productList1.length; i++) {
                  if (this.productList1[i]['item_id'] == product.item_id) {
                    this.productList1[i]['item_qty'] = qyt
                    this.productList1[i]['row_total'] = data.response.row_total
                    this.productList1[i]['margin'] = data.response.margin
                    this.productList1[i]['price'] = data.response.price
                  }
                }
              }
              this.statePersist.emitOrderDetailData('updae order Deatil')
            }
            else{
              if (data.status == 1169) {
                for (let i = 0; i < this.recommendedProducts.length; i++) {
                  if (this.recommendedProducts[i].recommend_id == recommend_id){
                    this.recommendedProducts[i].products = this.recommendedProducts[i].products.filter(item => item.product_id !== product.product_id);
                  }}
                  
                 
              }
              else if (data.status == 2211){
                this.alertService.error(data.response)
                this.recommendedProducts = [];
                this.noRecord2 = true;
                this.recommendedProductsList()
                this.statePersist.emitOrderDetailData('updae order Deatil')
              }
              else if(data.status == 1180){
                localStorage.setItem('closeStorInfoMessage', data.response.msg)
                document.getElementById("openclosedStoreInfo").click();
                for (let i = 0; i < this.recommendedProducts.length; i++) {
                  if (this.recommendedProducts[i].recommend_id == recommend_id){
                    for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
                      var qtyValue = this.recommendedProducts[i].products[j]['item_qty'];
                      if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
                        this.recommendedProducts[i].products[j]['item_qty'] = qtyValue
                      }
                    }
                  }}
              const currentUrl = this.router.url;
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([currentUrl]);
              });
              }
              else if (data.status == 1163) {
                for (let i = 0; i < this.recommendedProducts.length; i++) {
                  if (this.recommendedProducts[i].recommend_id == recommend_id){
                    this.recommendedProducts[i].products = this.recommendedProducts[i].products.filter(item => item.product_id !== product.product_id);
                  }}
                this.statePersist.emitoutOfStockData('out of stock update')
              }
              else {
                for (let i = 0; i < this.recommendedProducts.length; i++) {
                  if (this.recommendedProducts[i].recommend_id == recommend_id){
                    for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
                      if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
                        this.recommendedProducts[i].products[j]['item_qty'] = qyt
                        this.recommendedProducts[i].products[j]['row_total'] = data.response.row_total
                        if(data.response?.margin){
                          this.recommendedProducts[i].products[j]['margin'] = data.response.margin
                        }
                        this.recommendedProducts[i].products[j]['price'] = data.response.price
                      }
                    }
                  }}
                
              }
              this.statePersist.emitOrderDetailData('updae order Deatil')
            }
            


          }

        }
      );
    }
    
  }

  removePopup(template: TemplateRef<any>, type, selectedProduct, recommend_id) {
    if(type != 'All'){
      
      this.removeProduct = selectedProduct
      this.removeType = type
      this.selectedRecommendation = recommend_id
      this.removeHeading = 'Are you sure you want to remove product from cart?'
    }
    else{
      this.removeProduct= {}
      this.selectedRecommendation=''
      this.removeType = ''
      this.removeHeading = 'Are you sure you want to remove products from cart?'
    }
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }

  async biTrackingcalling(product, trackingid){
    let birecommendObj;
    birecommendObj =  {"sku":product.sku, "bi_recommendation_id" : this.selectedRecommendation, "bi_tracking_identifier": trackingid}
    
    this.productService.biRecommend(birecommendObj).subscribe(
      data => {})
    
  }

  removeItem(product, recommend_id){
    let fordata;
    if (this.removeType == 'All'){
      this.googleAnalyticsService.eventEmitter(SharedConsts.BASKET_REMOVE_ALL_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.BASKET_REMOVE_ALL_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    }
    else{
      this.googleAnalyticsService.eventEmitter(SharedConsts.BASKET_REMOVE_CART_ITEM_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.BASKET_REMOVE_ALL_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    }
    this.componentLoaded = false;
    fordata = {'item_id': product.item_id,'collect_totals':true}
    this.bsModalRef.hide();
    this.cartService.removeItem(fordata)
      .subscribe(
        data => {
          if(this.selectedRecommendation !== ''){
            this.biTrackingcalling(product, CartModuleConsts.BI_TRACKING_IDENTIFIER_TOREMOVE)
          }
          if (data.response) {
            this.bsModalRef.hide();
            if (this.removeType == 'All'){
              this.statePersist.emitminiCartData('min cart update')
            }
            if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              const currentUrl = this.router.url;
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([currentUrl]);
              });
            }
            else if (data.status == 2212){
              this.alertService.error(data.response)
            }
            else if (data.status == 2211 && this.removeType == 'list1'){
              this.alertService.error(data.response)
              this.productList1 = [];
              this.nextPage1 = 1;
              this.totalProductCount1 = 0;
              this.totalProductPages1 = 1
              this.noRecord1 = true;
              this.getCartItems()
              this.statePersist.emitOrderDetailData('updae order Deatil')
            }
            else if (data.status == 2211 && this.removeType != 'list1'){
              this.alertService.error(data.response)
              this.recommendedProducts = [];
              this.noRecord2 = true;
              this.recommendedProductsList()
              this.statePersist.emitOrderDetailData('updae order Deatil')
            }
            else if (this.removeType == 'list1'){

              this.productList1 = this.productList1.filter(item => item.item_id !== product.item_id);
              this.totalProductCount1 = this.totalProductCount1 - 1
              this.removeItemsCount += 1

              this.nextPage1 = 1;

              this.statePersist.emitOrderDetailData('order details with mycart')
              // this.statePersist.emitmobileListCountDetails('mobile count change')
              this.alertService.success('Product removed.')
              
            }
            else{
              for (let i = 0; i < this.recommendedProducts.length; i++) {
                if (this.recommendedProducts[i].recommend_id == recommend_id){
                  this.recommendedProducts[i].products = this.recommendedProducts[i].products.filter(item => item.item_id !== product.item_id);
                  this.recommendedProducts[i].total_products = this.recommendedProducts[i].total_products - 1
                  this.totalProductCount1 = this.totalProductCount1 - 1
                  if (this.recommendedProducts[i].total_products == 0){
                    this.recommendedProducts = [];
                    this.noRecord2 = true;
                    this.recommendedProductsList()
                  }
                }}
              this.totalProductCount2 = this.totalProductCount2 - 1
              
              this.statePersist.emitOrderDetailData('updae order Deatil')
              this.statePersist.emitmobileListCountDetails('mobile count change')
              this.alertService.success('Product removed.')
              
              
            }

            this.componentLoaded = true;
            
          }
            
          }

      )

  }

  clearCart(){
    this.bsModalRef.hide();
    this.componentLoaded = false;
    this.googleAnalyticsService.eventEmitter(SharedConsts.BASKET_REMOVE_ALL_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.BASKET_REMOVE_ALL_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    let obj ={};
    if (this.recommendedProducts.length >0){
      obj = {'bi_tracking_identifier':CartModuleConsts.BI_TRACKING_IDENTIFIER_TOREMOVE}
    }
    this.cartService.clearCart(obj)
      .subscribe(
        data => {
          if (data.response) {
            if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
            }
            else{
              this.removeItemsCount = this.totalProductCount1
              this.productList1 = [];
              this.nextPage1 = 1;
              this.totalProductCount1 = 0;
              this.totalProductPages1 = 1
              this.noRecord1 = true;

  
              this.recommendedProducts = [];
              this.noRecord2 = true;

              this.statePersist.emitOrderDetailData('update order details norefresh')
              this.statePersist.emitmobileListCountDetails('mobile count change norefresh')              
              
              this.alertService.success('Products removed.')

            }
            this.componentLoaded = true;
          }
            
          }

      )
  }

  removeonSpinnerPopup(template: TemplateRef<any>, selectedProduct, type, recommend_id) {
    this.removeProduct = selectedProduct
    this.selectedRecommendation = recommend_id
    this.removeHeading = 'Are you sure you want to remove product from cart?'
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }

  cancleRequest(product, recommend_id){
    this.bsModalRef.hide()
    if(this.removeType == 'list1'){
      for (let i = 0; i < this.productList1.length; i++) {
        if (this.productList1[i]['product_id'] == product.product_id) {
          this.productList1[i]['item_qty'] = '1'
        }
      }
    }
    else{
      
      for (let i = 0; i < this.recommendedProducts.length; i++) {
        if (this.recommendedProducts[i].recommend_id == recommend_id){
          for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
            if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
              this.recommendedProducts[i].products[j]['item_qty'] = '1'
            }
          }
        }}
    }
  }
  
}
